<app-common-header [isLogoIconBlue]="true" icon="logo-new-full" />
